// 2026-10-25 · Descargas del worker según el entorno del Front (REACT_APP_ENV).
// Producción (REACT_APP_ENV=Production) → workers de producción; cualquier otro (dev = "Staging",
// local = "Development") → workers de desarrollo, que hablan con el API de dev y se instalan
// aparte («TakeMyOrder Worker DEV» / com.takemyorder.worker.staging).
// Los publican solas las pipelines de los repos Worker y WORKER_ANDROID: develop → dev, master → producción.

export const WORKER_DOWNLOADS_BY_ENV = {
  production: {
    env: "production",
    windows: "https://worker.takemyorder.es/setup.exe",
    android: "https://play.google.com/store/apps/details?id=com.takemyorder.worker",
    androidLabel: "Google Play",
  },
  dev: {
    env: "dev",
    windows: "https://workerdev.takemyorder.es/setup.exe",
    android: "https://tmofrontcdndev.blob.core.windows.net/workers/android/worker-dev.apk",
    androidLabel: "APK de desarrollo",
  },
};

export const workerDownloadsFor = (reactAppEnv) =>
  String(reactAppEnv || "").toLowerCase() === "production" ? WORKER_DOWNLOADS_BY_ENV.production : WORKER_DOWNLOADS_BY_ENV.dev;

const WORKER_DOWNLOADS = workerDownloadsFor(process.env.REACT_APP_ENV);

export default WORKER_DOWNLOADS;
